import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";
import SolutionGraphic from "./Solution.png";
import RiskGraphic from "./RiskFree.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-6">
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID MFA API" className={styles.tabletImage} src={ArticleGraphic} />
                                </div>
                            </div>
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Add Multi-Factor Authentication to any existing application" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            Applications that only use a password to login are at a greater risk of hacking. Adding a second layer to the login process exponentially improves application 
                                            security. This is called Multi-Factor Authentication (MFA) or Two-Factor Authentication (2FA).
                                        </p>
                                        <p>
                                            Building Multi-Factor Authentication into applications on your own has inherent risks. Security best-practices are crucial to ensuring the safety of your data. 
                                            Additionally, it takes a lot of time and effort to build it correctly without introducing security holes. EngineID have built a solution that makes adding 
                                            multi-factor authentication to your application easy and secure.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-center pt-0">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How can we help?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <p>
                                        EngineID provides you all the tools you need to plug in Multi-Factor Authentication quickly and securely to your existing applications. Send login codes directly to your user’s mobile device using the EngineID mobile app for Android and iOS.
                                    </p>
                                    <p>
                                        We have done the hard work to build in all the additional safety features and mechanisms to ensure that when you add Multi-Factor Authentication to your application, it is being done using industry best practices.
                                    </p>
                                    <p>
                                        Combining your existing password login with EngineID’s Multi-Factor Authentication framework significantly improves the security for your application. We provide the framework for sending login codes and verifying them, and better yet, it’s all hosted on the cloud and ready to go right now.
                                    </p>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How it works?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <a href={SolutionGraphic}><img alt="EngineID MFA API" className={styles.solutionImage} src={SolutionGraphic} /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-center">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Relying on just a password is risky for the following reasons" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <p>
                                        <ul>
                                            <li>Users may have weak passwords which can be easily guessed.</li>
                                            <li>Users may use the same passwords across many applications. If one of the other applications becomes compromised, your application also becomes compromised without you even knowing it.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-6">
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Why use EngineID?" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            EngineID specializes in Identity and Authentication solutions. Our feature rich platform solves a wide range of complex challenges, with Multi-Factor Authentication a core component of what we do. 
                                        </p>
                                        <p>
                                            When you use EngineID, you receive many benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>An expert team of Identity and Authentication specialists and developers. Our focus is on solving complex challenges such as Multi-Factor Authentication for our customers.</li>
                                                <li>No additional servers required. Connect to our solution in the cloud to easily implement Multi-Factor Authentication.</li>
                                                <li>Ongoing support and enhancements of our solution. As a cloud product, we handle all patching and upgrades.</li>
                                                <li>Ongoing testing of our solution improves confidence of a secure solution.</li>
                                                <li>Our product can cater for any number of authentication requests, no matter how large or small.</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Authentication is important to get right. Let EngineID up-lift your authentication strategy with confidence.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID MFA API" className={styles.tabletImage} src={RiskGraphic} />
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}